import { Box, Typography } from "@mui/material";
import { motion } from "framer-motion";
import React from "react";

interface StatsCardItem {
  title: string;
  value: string;
  icon: string;
  rating?: string;
  arrow: string;
  bg: string;
  res: string;
  aColor?: string;
}

interface StatsCardGridProps {
  items: StatsCardItem[];
  columns?: { md: string; xs: string };
  gap?: string;
}

const StatsCardGrid: React.FC<StatsCardGridProps> = ({
  items,
  columns = { md: "1fr 1fr 1fr 1fr", xs: "1fr" },
  gap = "30px",
}) => {
  return (
    <Box width="100%">
      <Box display="grid" gridTemplateColumns={columns} gap={gap}>
        {items.map((item, index) => (
          <motion.button
            key={index}
            whileHover={{ scale: 1.0 }}
            whileTap={{ scale: 0.9 }}
            style={{
              backgroundColor: "#FFFFFF",
              borderRadius: "12px",
              border: "1px solid #E4E7EC",
              padding: "16px",
            }}
          >
            <Box
              display="flex"
              alignItems="start"
              justifyContent="space-between"
            >
              <Box>
                <Typography fontSize="16px" fontWeight={600} color="#202224">
                  {item.title}
                </Typography>
                <Typography mt="7px" fontSize="30px" fontWeight={700}>
                  {item.value}
                </Typography>
              </Box>
              <Box
                bgcolor={item.bg}
                borderRadius="100%"
                height="60px"
                width="60px"
                display="flex"
                alignItems="center"
                justifyContent="center"
              >
                <img
                  height="32.73px"
                  width="32.73px"
                  src={item.icon}
                  alt={item.title}
                />
              </Box>
            </Box>
            {item.rating && (
              <Typography
                fontSize="14px"
                fontWeight={600}
                mt="14px"
                sx={{ display: "flex", gap: "2px" }}
              >
                <img height="24px" width="24px" src={item.arrow} alt="alt" />
                <span style={{ color: item.aColor || "#379E66" }}>
                  {item.rating}%
                </span>
                <span style={{ color: "#98A2B3", fontSize: "13px" }}>
                  {item.res}
                </span>
              </Typography>
            )}
          </motion.button>
        ))}
      </Box>
    </Box>
  );
};

export default StatsCardGrid;
